// Components
import CheckboxInput from 'components/form/checkbox-input'
import Field from 'components/form/field'
import { TextInput } from 'components/form/text-input'
import { Link } from 'components/link'
import Tooltip from 'components/tooltip'
import { range } from 'lodash'
// Modules
import { DI } from 'modules'
import PaymentBlock, {
  PaymentBlockFields,
} from 'pages/business/components/payment-block'
import * as React from 'react'
import Instructions from './instructions'

const PaymentLicense = ({ common, disabled, form, onValidateForm }) => {
  const { strings } = common
  const { agreement_request } = form

  const prefix = 'page.payment.licence'
  const confirm1Prefix = `${prefix}.confirm_1`
  const confirm2Prefix = `${prefix}.confirm_2`
  const urlPrefix = `${prefix}.url.tooltip.list`

  return (
    <PaymentBlock
      text={strings[`${prefix}.text`]}
      title={strings[`${prefix}.title`]}
    >
      <PaymentBlockFields>
        {[1, 2].map((index, _index) => (
          <Field key={index} label={`URL #${index}`}>
            <Tooltip
              content={
                <>
                  {strings[urlPrefix]}
                  <ul>
                    {range(1, 3).map(index => (
                      <li key={index}>
                        {strings[`${urlPrefix}.item_${index}`]}
                      </li>
                    ))}
                  </ul>
                </>
              }
              placement="right"
            >
              <div>
                <TextInput
                  disabled={disabled}
                  isRequired={!agreement_request[`url_${index === 1 ? 2 : 1}`]}
                  isUrl
                  name={`agreement_request[url_${index}]`}
                  onValidateForm={onValidateForm}
                  value={agreement_request[`url_${index}`]}
                />
              </div>
            </Tooltip>
          </Field>
        ))}

        <div className="field-hr" />

        <div className="field field--su-checkbox">
          <Tooltip
            content={
              <>
                {strings[`${confirm1Prefix}.tooltip.list`]}
                <ul>
                  {range(1, 4).map(index => (
                    <li key={index}>
                      {strings[`${confirm1Prefix}.tooltip.list.item_${index}`]}
                    </li>
                  ))}
                </ul>
              </>
            }
            placement="right"
          >
            <div>
              <CheckboxInput
                checked={disabled ? true : agreement_request.confirm_1}
                isRequired
                name="agreement_request[confirm_1]"
                onValidateForm={onValidateForm}
              >
                {strings[confirm1Prefix]}
              </CheckboxInput>
            </div>
          </Tooltip>
        </div>

        <div className="field">
          <div className="buying__requirement">
            <ul>
              <li>{strings[`${prefix}.requirement_1`]}</li>
            </ul>

            <ul>
              <li>
                {strings[`${prefix}.requirement_2_1`]}&nbsp;
                <Tooltip content={strings[`${prefix}.requirement_2.tooltip`]}>
                  <span className="question" />
                </Tooltip>
                &nbsp;
                {strings[`${prefix}.requirement_2_2`]}
              </li>
            </ul>

            <p>
              {strings[`${prefix}.requirement_3`]}&nbsp;
              <a href={`mailto:${strings['pass.email']}`}>
                {strings['pass.email']}
              </a>
            </p>

            <Instructions />
          </div>
        </div>

        <div className="field field--su-checkbox">
          <Tooltip
            content={
              <>
                {strings[`${confirm2Prefix}.tooltip.list`]}
                <ul>
                  {range(1, 4).map(index => (
                    <li key={index}>
                      {strings[`${confirm2Prefix}.tooltip.list.item_${index}`]}
                    </li>
                  ))}
                </ul>
              </>
            }
            placement="right"
          >
            <div>
              <CheckboxInput
                checked={disabled ? true : agreement_request.confirm_2}
                isRequired
                name="agreement_request[confirm_2]"
                onValidateForm={onValidateForm}
              >
                {strings[confirm2Prefix]}

                <Link
                  rel="noreferrer noopenner"
                  target="_blank"
                  to="/terms-of-use"
                >
                  {strings[`${confirm2Prefix}.link`]}
                </Link>
              </CheckboxInput>
            </div>
          </Tooltip>
        </div>

        <div className="buying__billing-info">{strings[prefix]}</div>
      </PaymentBlockFields>
    </PaymentBlock>
  )
}

export default DI(['common'])(PaymentLicense)
